import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DualStateButton,
  getActionIconButtonSize,
  Icon,
} from './inline-base-styles';
import { faBan, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { Theme, useMediaQuery } from '@mui/material';

interface EditButtonProps {
  text?: string;
  currentlyActive?: boolean;
  disabled?: boolean;
  toggleMutation: () => void;
  children?: React.ReactNode;
}

const dimension = getActionIconButtonSize('small');
const mobileButtonStyle = {
  width: dimension,
  minWidth: dimension,
  maxWidth: dimension,
  height: dimension,
  minHeight: dimension,
  maxHeight: dimension,
  marginTop: '0',
  marginBottom: '0',
  padding: '0',
};

export const ToggleButton: React.FC<EditButtonProps> = ({
  toggleMutation,
  text,
  currentlyActive,
  disabled,
}) => {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );
  const { t } = useTranslation();
  const icon = currentlyActive ? faBan : faPowerOff;

  return (
    <DualStateButton
      variant="contained"
      size="small"
      disabled={disabled}
      $isEnabled={currentlyActive}
      startIcon={isMobile ? undefined : <Icon icon={icon} size="sm" />}
      onClick={() => toggleMutation()}
      style={isMobile ? mobileButtonStyle : { marginTop: 'auto' }}
    >
      {isMobile ? (
        <Icon icon={icon} size="sm" />
      ) : (
        <span className="d-none d-lg-inline">
          {String(
            t(
              text || currentlyActive
                ? 'global.buttons.deactivate'
                : 'global.buttons.activate',
            ),
          )}
        </span>
      )}
    </DualStateButton>
  );
};
